// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var ArrowDashRight = React.forwardRef(function ArrowDashRight(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ArrowDashRight" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.12109 10.7415H4.92829L4.92829 13.2963H2.12109L2.12109 10.7415ZM6.96962 10.7443L11.0523 10.7352V13.2867L6.96962 13.2958V10.7443ZM22.1211 12.0117L15.4204 19.1209H15.1995L13.5711 17.4235L17.4266 13.2908L13.0936 13.2908V10.736L17.4184 10.736L13.5693 6.69187L15.3098 4.87891L22.1211 12.0117Z", fill: "currentColor" }))));
});
ArrowDashRight.displayName = 'ArrowDashRight';
export default ArrowDashRight;
//# sourceMappingURL=ArrowDashRight.js.map